export { default } from 'features/menu/routes/menu-favorites-route';
